import { Pipe, PipeTransform } from "@angular/core";
import { CustomerTaxCategory } from "../model";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
  standalone: true,
  name: 'fpa',
  pure: true
})
export class FPAPipe implements PipeTransform {

  constructor(protected translateService: TranslateService) {

    }

    transform(value: CustomerTaxCategory): string {
        switch (value) {
          case CustomerTaxCategory.EU:
            return this.translateService.instant("tax.1");
          case CustomerTaxCategory.NOT_EU:
            return this.translateService.instant("tax.2");
          case CustomerTaxCategory.NORMAL:
            return this.translateService.instant("tax.3");
          case CustomerTaxCategory.SPECIAL:
            return this.translateService.instant("tax.4");
        }

        return 'Δεν έχει οριστεί (0%)';
    }


}
